import { render } from "./PoliticaPrivacidade.vue?vue&type=template&id=1700b220&scoped=true"
import script from "./PoliticaPrivacidade.vue?vue&type=script&lang=js"
export * from "./PoliticaPrivacidade.vue?vue&type=script&lang=js"

import "./PoliticaPrivacidade.vue?vue&type=style&index=0&id=1700b220&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1700b220"]])

export default __exports__